import request from '@/utils/request'

const chechangJwsVehicle = {
  communitySelect(query) {
    return request({ url: '/chechang/jws-vehicle/communitySelect', method: 'get', params: query })
  },
  parkingSpaceSelect(query) {
    return request({ url: '/chechang/jws-vehicle/parkingSpaceSelect', method: 'get', params: query })
  },
  roomSelect(query) {
    return request({ url: '/chechang/jws-vehicle/roomSelect', method: 'get', params: query })
  },
  findPersonCode(query) {
    return request({ url: '/chechang/jws-vehicle/findPersonCode', method: 'get', params: query })
  },
  cityOptions(query) {
    return request({ url: '/chechang/jws-vehicle/cityOptions', method: 'get', params: query })
  },
  list(query) {
    return request({ url: '/chechang/jws-vehicle/list', method: 'get', params: query })
  },
  detail(query) {
    return request({ url: '/chechang/jws-vehicle/detail', method: 'get', params: query })
  },
  syncParkingFee(data) {
    return request({
      url: '/chechang/jws-vehicle/syncParkingFee',
      method: 'post',
      data,
      timeout: 120000
    })
  },
  add(data) {
    return request({ url: '/chechang/jws-vehicle/add', method: 'post', data })
  },
  update(data) {
    return request({ url: '/chechang/jws-vehicle/update', method: 'post', data })
  },
  remove(data) {
    return request({ url: '/chechang/jws-vehicle/remove', method: 'post', data })
  },
  statusByPlate(query) {
    return request({ url: '/chechang/jws-vehicle/statusByPlate', method: 'get', params: query })
  },
  statusCrossRecordsByPlate(query) {
    return request({ url: '/chechang/jws-vehicle/statusCrossRecordsByPlate', method: 'get', params: query })
  },
  crossRecords(query) {
    return request({ url: '/chechang/jws-vehicle/crossRecords', method: 'get', params: query })
  },
  status(query) {
    return request({ url: '/chechang/jws-vehicle/status', method: 'get', params: query })
  },
  operationLogs(query) {
    return request({ url: '/chechang/jws-vehicle/operationLogs', method: 'get', params: query })
  },
  sync(data) {
    return request({ url: '/chechang/jws-vehicle/sync', method: 'post', data })
  },
  syncProgress(query) {
    return request({ url: '/chechang/jws-vehicle/sync/progress', method: 'get', params: query })
  },
  syncHistory(query) {
    return request({ url: '/chechang/jws-vehicle/sync/history', method: 'get', params: query })
  },
  diffList(query) {
    return request({ url: '/chechang/jws-vehicle/sync/diff/list', method: 'get', params: query })
  },
  diffOverrideOne(data) {
    return request({ url: '/chechang/jws-vehicle/sync/diff/overrideOne', method: 'post', data })
  },
  diffOverrideAll(data) {
    return request({ url: '/chechang/jws-vehicle/sync/diff/overrideAll', method: 'post', data })
  },
  export(data) {
    return request({ url: '/chechang/jws-vehicle/export', method: 'post', data })
  },
  importExcel(data) {
    return request({ url: '/chechang/jws-vehicle/importExcel', method: 'post', data })
  }
}

export default chechangJwsVehicle
